import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { CiqProNavConfigProvider } from './ciqpro-nav-config.provider';
import { CanAccessCiqProGuard } from './ciqpro-navigation-guard';
import { CIQPRO_PATH } from './constants';

export const loadModule = () => import('@capital-access/ciqpro/client').then(m => m.CiqProClientModule);

// @dynamic
@NgModule({
  imports: [
    CommonModule,
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: CIQPRO_PATH,
          canActivate: [CanAccessCiqProGuard],
          canActivateChild: [CanAccessCiqProGuard],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(CiqProNavConfigProvider), CanAccessCiqProGuard]
})
export class CiqproClientLazyModule {}
